import { render, staticRenderFns } from "./UploadDocumentAction.vue?vue&type=template&id=42d37b6e"
import script from "./UploadDocumentAction.vue?vue&type=script&lang=js"
export * from "./UploadDocumentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports